import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// A development build served locally runs against the real dev project, whose App Check
// backend only trusts a registered token; reCAPTCHA cannot vouch for localhost. `true`
// makes the SDK generate a token for this browser, print it to the console once, and keep
// it in IndexedDB; register it under the dev web app in the Firebase console
// (docs/SETUP.md). Read by initializeAppCheck, so it is set before anything bootstraps.
// Localhost only: `deploy:dev` publishes the dev environment to dev.parkingless.com,
// where reCAPTCHA does vouch, and a debug token there is one nobody registered, refused
// with a 403 in every browser. Never in a production build, and pointless in the emulator
// configuration, which registers no provider.
const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
if (!environment.production && !environment.useEmulators && environment.appCheck && isLocalhost) {
  (self as { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean | string }).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
